// extracted by mini-css-extract-plugin
export var rateTable = "_46-0";